<template>
  <div class="reward">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="topColumn"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
      @changeMethod="changeMethod"
    ></sirui-search>
    <div class="result-table">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        @chooseClick="chooseClick"
        :loading="loading"
        @handleSelectionChange="handleSelectionChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @dblclickEvent="dblclickEvent"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        :cellStyle="cellStyle"
        :cellClick="cellClick"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
      <SettleDialog
        v-if="dialogVisible"
        ref="settleDialogRefs"
        @close="closeDialog"
        :dialogVisible="dialogVisible"
        :dialogTitle="dialogTitle"
        :dialogType="dialogType"
        :settleId="settleId"
      />
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { mapState } from 'vuex';
  import {
    searchColumns,
    defaultMenuList,
    defaultTableColumns,
    auditStatusList,
    settlementStatusList,
  } from '../data';
  import SettleDialog from '../component/settleDialog.vue';
  import API from '@/api/property/reward';
  // import DATA_BASE_API from '@/api/dataBase';
  // import COMPANY_API from '@/api/masterData/company.js';
  import XEUtils from 'xe-utils';
  import BASE_API from '@/api/dataBase.js';
  export default {
    name: 'RewardOverview',
    components: {
      SiruiSearch,
      SettleDialog,
    },
    mixins: [],
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
      });
    },
    data() {
      return {
        auditStatusList,
        settlementStatusList,
        loading: false,
        query: {
          rewardSettlementNo: '',
          nicheCompanyNo: '',
          nicheDepartmentCode: '',
          nicheNo: '',
          contractNo: '',
          customerName: '',
          settlementStatus: '',
          auditStatus: '',
          createPersonName: '',
          gmtCreateEnd: '',
          gmtCreateStart: '',
        },
        menuButtonList: [],
        defaultMenuList,
        defaultTableColumns,
        columnList: [],
        multipleSelection: [],
        tableData: [],
        dialogVisible: false,
        dialogTitle: '',
        dialogType: '',
        settleId: '',
        companyList: [],
        departmentList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      topColumn() {
        return searchColumns(this);
      },
    },
    created() {
      this.query.nicheCompanyNo = this.userInfo.companyCode;
      // this.query.nicheDepartmentCode = this.userInfo.departmentCode;
      this.getDepartmentList(this.userInfo.companyCode);
    },
    methods: {
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(this.defaultTableColumns).then((res) => {
          console.log(res, '11');
          this.columnList = this.defaultTableColumns;
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '111');
          this.menuButtonList = e.length > 0 ? e : this.defaultMenuList;
          // this.menuButtonList = this.defaultMenuList || [];
          this.getColumnInfo();
        });
      },
      // 重置
      resetBtnClick() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      search() {
        console.log('search');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      handleSizeChange() {
        this.getData();
      },
      handleCurrentChange() {
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        if (params.ruleDepartmentCode) {
          params.scopeDepartmentNoList = [params.ruleDepartmentCode];
        }
        this.$axios.post(API.REWARD_LIST_PAGE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData =
              res.data.data?.records?.map((item) => {
                return {
                  ...item,
                  auditStatusName: this.transferSelect(item.auditStatus, this.auditStatusList),
                  settlementStatusName: item.settlementStatus
                    ? this.transferSelect(item.settlementStatus, this.settlementStatusList)
                    : '',
                };
              }) || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      dblclickEvent({ row }) {
        console.log('detail', row);
      },
      chooseClick(type) {
        console.log(type, '111111');
        if (type === 'apply') {
          this.handleApply();
        } else if (type === 'settle') {
          this.handleSettle();
        } else if (type === 'audit') {
          this.handleAudit();
        } else if (type === 'expor') {
          this.handleExport();
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'error',
          });
          return false;
        }
        return true;
      },
      handleExport() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        const ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        params.ids = ids;
        this.$axios.post(API.EXPORT_API, params).then((res) => {
          console.log(res, '1111');
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      handleApply() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          console.log(selectedData, '1111111111');
          // 待提交 审核驳回都能结算申请
          if (selectedData.auditStatus === '01' || selectedData.auditStatus === '04') {
            console.log('佣金结算申请弹框');
            this.dialogVisible = true;
            this.dialogTitle = '佣金结算申请';
            this.dialogType = 'apply';
            this.settleId = selectedData.id || '12';
          } else {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持结算申请，请核实！',
              type: 'error',
            });
          }
        }
      },
      handleSettle() {
        // const selectedData = this.multipleSelection[0] || {};
        // this.dialogVisible = true;
        // this.dialogTitle = '佣金结算';
        // this.dialogType = 'settle';
        // this.settleId = selectedData.id || '12';
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.auditStatus === '03' && selectedData.settlementStatus === '01') {
            console.log('佣金结算弹框');
            this.dialogVisible = true;
            this.dialogTitle = '佣金结算';
            this.dialogType = 'settle';
            this.settleId = selectedData.id || '12';
          } else {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持结算申请，请核实！',
              type: 'error',
            });
          }
        }
      },
      handleAudit() {
        // const query = {
        //   id: this.multipleSelection[0]?.id || '0',
        // };
        // let path = {
        //   fromPath: {
        //     path: this.$route.path,
        //     name: this.$route.name,
        //     meta: { keepAlive: true },
        //   },
        //   toPath: {
        //     path: '/property/merchant/reward/detail',
        //     name: 'rewardDetail',
        //     meta: { keepAlive: false },
        //     query,
        //   },
        // };
        // this.$store.dispatch('tagsView/backTabView', path).then(() => {
        //   this.$nextTick(() => {
        //     this.$router.push(path.toPath);
        //   });
        // });
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.auditStatus === '02') {
            console.log('审核招商奖励');
            const query = {
              id: this.multipleSelection[0]?.id || '0',
            };
            let path = {
              fromPath: {
                path: this.$route.path,
                name: this.$route.name,
                meta: { keepAlive: true },
              },
              toPath: {
                path: '/property/merchant/reward/detail',
                name: 'rewardAudit',
                meta: { keepAlive: false },
                query,
              },
            };
            this.$store.dispatch('tagsView/backTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path.toPath);
              });
            });
          } else {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持审核，请核实！',
              type: 'error',
            });
          }
        }
      },
      closeDialog(val) {
        this.dialogVisible = false;
        if (val === 'refresh') {
          this.getData();
        }
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      changeMethod(row) {
        console.log(row, '11');
        if (row.prop === 'nicheCompanyNo') {
          // 获取公司下的部门
          this.departmentList = [];
          this.query.nicheDepartmentCode = '';
          this.getDepartmentList(row.val);
          // this.query.nicheCompanyNo = row.val;
        }
      },
      // 获取当前登录人所在的部门
      getDepartmentList(code) {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = (res.data.data.personDepartmentInfo || []).map((v) => {
              return {
                label: v.personDepartmentName,
                value: v.personDepartmentCode,
              };
            });
          } else {
            this.departmentList = [];
          }
        });
      },
      cellStyle({ column }) {
        if (
          column.property == 'rewardSettlementNo' ||
          column.property == 'nicheNo' ||
          column.property == 'contractNo'
        ) {
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property == 'nicheNo') {
          this.toDetailPage(1, val.row.nicheId);
        } else if (val.column?.property == 'contractNo') {
          console.log('clickContract', val);
          const path = {
            path: 'propert/detailLeaseContract',
            name: 'detailLeaseContract',
            meta: {
              keepAlive: true,
              title: '租赁合同详情',
            },
            query: {
              type: 'detail',
              contractNo: val.row.contractNo,
            },
          };
          this.$router.push(path);
        } else if (val.column?.property == 'rewardSettlementNo') {
          const row = val.row || {};
          // if (row.auditStatus === '01' || row.auditStatus === '02') {
          //   return this.$message({
          //     showClose: true,
          //     message: '该状态的数据暂未审核',
          //     type: 'error',
          //   });
          // }
          const query = {
            id: row.id || '0',
            type: 'detail',
          };
          let path = {
            fromPath: {
              path: this.$route.path,
              name: this.$route.name,
              meta: { keepAlive: true },
            },
            toPath: {
              path: '/property/merchant/reward/detail',
              name: 'rewardDetail',
              meta: { keepAlive: false },
              query,
            },
          };
          this.$store.dispatch('tagsView/backTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path.toPath);
            });
          });
        }
      },
      toDetailPage(pageMode = 0, id) {
        let name = '';
        let subPath = '';
        let params = {};

        if (pageMode == 0) {
          subPath = 'create';
          name = 'merchantCreate';
        } else if (pageMode == 1) {
          subPath = 'detail';
          name = 'merchantDetail';
          params.id = id;
        } else if (pageMode == 2) {
          subPath = 'edit';
          name = 'merchantEdit';
          params.id = id;
        }
        params.pageMode = pageMode;

        let path = {
          path: '/property/merchant/center/' + subPath,
          name: name,
          meta: {
            keepAlive: true,
            title: name,
          },
          query: params,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
